import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    openId: null,
  },
  mutations: {
    setOpenId (state, openId) {
      state.openId = openId
    },
  },
  actions: {
  },
  modules: {
  }
})
